
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/punctuation-explanation';

const mainimage = '/Images/enough1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "punctuation" },
];

const Punctuation = () => (
  <GrammarPageLayout
    level="B1"
    title="Punctuation"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Punctuation Exercises"
    seoDescription="Perfect your written English with commas, apostrophes, colons, and more. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Punctuation;

